import { useQuery } from "@tanstack/react-query";

import { retryDelay } from "../config/queryConfig";
import { getProductDetails } from "../services/productDetailsService";
import {
  ProductDetailsRequest,
  ProductDetailsResponse,
} from "../types/products";

interface UseProductDetailsOptions {
  productId: string;
  retailer: string;
  enabled?: boolean;
}

export const useProductDetails = ({
  productId,
  retailer,
  enabled = true,
}: UseProductDetailsOptions) => {
  const {
    data,
    isLoading,
    error,
    refetch,
    dataUpdatedAt,
  } = useQuery({
    queryKey: ["productDetails", productId, retailer],
    queryFn: () => {
      const request: ProductDetailsRequest = {
        productId,
        retailer,
      };

      return getProductDetails(request);
    },
    enabled: Boolean(productId) && Boolean(retailer) && enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes — details are static (title, images, features)
    gcTime: 30 * 60 * 1000, // 30 minutes
    retry: 3,
    retryDelay,
  });

  return {
    data: data?.data,
    isLoading,
    error,
    refetch,
    dataUpdatedAt,
  };
};
